import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

const oggiISO = () => new Date().toISOString().split('T')[0]

function normalizzaLink(link) {
  const pulito = (link || '').trim()
  if (!pulito) return null
  return /^https?:\/\//i.test(pulito) ? pulito : `https://${pulito}`
}

function calcolaStato(s) {
  const oggi = oggiISO()
  if (!s.attivo) return { label: 'Disattivato', colore: 'var(--muted)' }
  if (s.data_inizio > oggi) return { label: 'Programmato', colore: 'var(--accent2)' }
  if (s.data_fine < oggi) return { label: 'Scaduto', colore: 'var(--red)' }
  return { label: 'Attivo', colore: 'var(--green)' }
}

const FORM_VUOTO = { nome: '', link: '', data_inizio: oggiISO(), data_fine: '', ordine: 0 }

export default function PannelloSponsor() {
  const [sponsor, setSponsor] = useState([])
  const [caricamento, setCaricamento] = useState(true)
  const [mostraForm, setMostraForm] = useState(false)
  const [form, setForm] = useState(FORM_VUOTO)
  const [fileImmagine, setFileImmagine] = useState(null)
  const [anteprimaImmagine, setAnteprimaImmagine] = useState(null)
  const [salvando, setSalvando] = useState(false)
  const [errore, setErrore] = useState('')
  const [confermaElimina, setConfermaElimina] = useState(null)
  const [toast, setToast] = useState('')
  const [modificaId, setModificaId] = useState(null) // null = nuovo sponsor, altrimenti id in modifica
  const [immagineEsistente, setImmagineEsistente] = useState(null) // url dell'immagine già caricata, se non se ne sceglie una nuova

  useEffect(() => { carica() }, [])

  function toast_msg(msg) {
    setToast(msg)
    setTimeout(() => setToast(''), 2500)
  }

  async function carica() {
    setCaricamento(true)
    const { data } = await supabase.from('sponsor').select('*').order('ordine', { ascending: true }).order('creato_il', { ascending: false })
    setSponsor(data || [])
    setCaricamento(false)
  }

  function selezionaFile(e) {
    const file = e.target.files?.[0]
    if (!file) return
    setFileImmagine(file)
    setAnteprimaImmagine(URL.createObjectURL(file))
  }

  function apriModifica(s) {
    setModificaId(s.id)
    setForm({ nome: s.nome, link: s.link || '', data_inizio: s.data_inizio, data_fine: s.data_fine, ordine: s.ordine })
    setImmagineEsistente(s.immagine_url)
    setFileImmagine(null)
    setAnteprimaImmagine(null)
    setErrore('')
    setMostraForm(true)
  }

  function chiudiForm() {
    setMostraForm(false)
    setModificaId(null)
    setForm(FORM_VUOTO)
    setFileImmagine(null)
    setAnteprimaImmagine(null)
    setImmagineEsistente(null)
    setErrore('')
  }

  async function salvaSponsor() {
    setErrore('')
    if (!form.nome.trim()) { setErrore('Inserisci il nome dello sponsor'); return }
    if (!fileImmagine && !immagineEsistente) { setErrore('Carica un\'immagine (logo o locandina)'); return }
    if (!form.data_inizio || !form.data_fine) { setErrore('Imposta data di inizio e fine contratto'); return }
    if (form.data_fine < form.data_inizio) { setErrore('La data di fine non può essere prima di quella di inizio'); return }

    setSalvando(true)
    try {
      let immagineUrl = immagineEsistente
      if (fileImmagine) {
        const estensione = fileImmagine.name.split('.').pop()
        const nomeFile = `${crypto.randomUUID()}.${estensione}`
        const { error: erroreUpload } = await supabase.storage.from('sponsor-immagini').upload(nomeFile, fileImmagine)
        if (erroreUpload) throw new Error(erroreUpload.message)
        const { data: pubblico } = supabase.storage.from('sponsor-immagini').getPublicUrl(nomeFile)
        immagineUrl = pubblico.publicUrl
      }

      const datiSponsor = {
        nome: form.nome.trim(),
        immagine_url: immagineUrl,
        link: normalizzaLink(form.link),
        data_inizio: form.data_inizio,
        data_fine: form.data_fine,
        ordine: Number(form.ordine) || 0,
      }

      const { error: erroreSalva } = modificaId
        ? await supabase.from('sponsor').update(datiSponsor).eq('id', modificaId)
        : await supabase.from('sponsor').insert(datiSponsor)
      if (erroreSalva) throw new Error(erroreSalva.message)

      toast_msg(modificaId ? '✅ Sponsor aggiornato' : '✅ Sponsor aggiunto')
      chiudiForm()
      carica()
    } catch (e) {
      setErrore('Errore: ' + e.message)
    }
    setSalvando(false)
  }

  async function toggleAttivo(s) {
    await supabase.from('sponsor').update({ attivo: !s.attivo }).eq('id', s.id)
    setSponsor(prev => prev.map(x => x.id === s.id ? { ...x, attivo: !s.attivo } : x))
    toast_msg(s.attivo ? '⏸️ Sponsor disattivato' : '▶️ Sponsor riattivato')
  }

  async function eliminaSponsor(s) {
    await supabase.from('sponsor').delete().eq('id', s.id)
    setSponsor(prev => prev.filter(x => x.id !== s.id))
    setConfermaElimina(null)
    toast_msg('🗑 Sponsor eliminato')
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: 12, color: 'var(--muted)' }}>{sponsor.length} sponsor totali</div>
        <button className="btn btn-primary" style={{ width: 'auto', padding: '8px 14px', fontSize: 13 }}
          onClick={() => { mostraForm ? chiudiForm() : setMostraForm(true) }}>
          {mostraForm ? 'Chiudi' : '+ Nuovo sponsor'}
        </button>
      </div>

      {/* Form nuovo sponsor / modifica */}
      {mostraForm && (
        <div className="card slide-up">
          <div className="card-header"><div className="card-title">{modificaId ? '✏️ Modifica sponsor' : '🏷️ Nuovo sponsor'}</div></div>
          <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div className="form-group">
              <label className="form-label">Nome sponsor</label>
              <input className="form-input" value={form.nome} onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} placeholder="Es. Palestra XYZ" />
            </div>

            <div className="form-group">
              <label className="form-label">Logo / locandina {modificaId && '(lascia vuoto per mantenere quella attuale)'}</label>
              <input type="file" accept="image/*" onChange={selezionaFile} style={{ fontSize: 12 }} />
              {(anteprimaImmagine || immagineEsistente) && (
                <img src={anteprimaImmagine || immagineEsistente} alt="anteprima" style={{ marginTop: 8, maxHeight: 120, borderRadius: 10, border: '1px solid var(--border)' }} />
              )}
            </div>

            <div className="form-group">
              <label className="form-label">Link (opzionale)</label>
              <input className="form-input" value={form.link} onChange={e => setForm(f => ({ ...f, link: e.target.value }))} placeholder="https://..." />
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              <div className="form-group" style={{ flex: 1 }}>
                <label className="form-label">Inizio contratto</label>
                <input className="form-input" type="date" value={form.data_inizio} onChange={e => setForm(f => ({ ...f, data_inizio: e.target.value }))} style={{ fontSize: 13 }} />
              </div>
              <div className="form-group" style={{ flex: 1 }}>
                <label className="form-label">Fine contratto</label>
                <input className="form-input" type="date" value={form.data_fine} onChange={e => setForm(f => ({ ...f, data_fine: e.target.value }))} style={{ fontSize: 13 }} />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Ordine di rotazione (facoltativo — più basso = mostrato prima)</label>
              <input className="form-input" type="number" value={form.ordine} onChange={e => setForm(f => ({ ...f, ordine: e.target.value }))} style={{ fontSize: 13 }} />
            </div>

            {errore && <div className="alert alert-warn"><span>⚠️</span><span>{errore}</span></div>}

            <button className="btn btn-primary" onClick={salvaSponsor} disabled={salvando}>
              {salvando ? '⏳ Salvataggio...' : modificaId ? '✅ Salva modifiche' : '✅ Salva sponsor'}
            </button>
          </div>
        </div>
      )}

      {/* Elenco sponsor */}
      {caricamento ? (
        <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40 }}>Caricamento...</div>
      ) : sponsor.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px 20px' }}>
          <div style={{ fontSize: 40, marginBottom: 10 }}>🏷️</div>
          <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 15, marginBottom: 6 }}>Nessuno sponsor</div>
          <div style={{ fontSize: 12, color: 'var(--muted)' }}>Aggiungi il primo sponsor per iniziare</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {sponsor.map(s => {
            const stato = calcolaStato(s)
            return (
              <div key={s.id} className="card">
                <div className="card-body" style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                  <img src={s.immagine_url} alt={s.nome} style={{ width: 52, height: 52, borderRadius: 10, objectFit: 'cover', border: '1px solid var(--border)', flexShrink: 0 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                      <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14 }}>{s.nome}</div>
                      <span style={{ fontSize: 10, fontWeight: 700, color: stato.colore, flexShrink: 0 }}>● {stato.label}</span>
                    </div>
                    <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
                      {new Date(s.data_inizio).toLocaleDateString('it-IT')} → {new Date(s.data_fine).toLocaleDateString('it-IT')}
                    </div>
                    <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
                      👁 {s.visualizzazioni} visualizzazioni · 👆 {s.click} click
                    </div>
                    {s.link && (
                      <div style={{ fontSize: 11, color: 'var(--accent2)', marginTop: 2, wordBreak: 'break-all' }}>{s.link}</div>
                    )}
                    <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
                      <button onClick={() => apriModifica(s)} style={{ background: 'none', border: '1px solid var(--accent2)', borderRadius: 8, padding: '5px 10px', color: 'var(--accent2)', cursor: 'pointer', fontSize: 11, fontWeight: 700, fontFamily: 'Syne' }}>
                        ✏️ Modifica
                      </button>
                      <button onClick={() => toggleAttivo(s)} style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 8, padding: '5px 10px', color: 'var(--text)', cursor: 'pointer', fontSize: 11, fontWeight: 700, fontFamily: 'Syne' }}>
                        {s.attivo ? '⏸ Disattiva' : '▶ Riattiva'}
                      </button>
                      <button onClick={() => setConfermaElimina(s)} style={{ background: 'none', border: '1px solid rgba(248,113,113,0.3)', borderRadius: 8, padding: '5px 10px', color: 'var(--red)', cursor: 'pointer', fontSize: 11, fontWeight: 700, fontFamily: 'Syne' }}>
                        ✕ Elimina
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )}

      {/* Conferma eliminazione */}
      {confermaElimina && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 300, padding: 20 }}>
          <div style={{ background: 'var(--surface)', borderRadius: 20, padding: 24, width: '100%', maxWidth: 380, border: '1px solid rgba(248,113,113,0.3)' }} className="slide-up">
            <div style={{ fontSize: 36, textAlign: 'center', marginBottom: 10 }}>⚠️</div>
            <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 16, textAlign: 'center', marginBottom: 8 }}>Eliminare {confermaElimina.nome}?</div>
            <div style={{ fontSize: 12, color: 'var(--muted)', textAlign: 'center', marginBottom: 18 }}>Il contratto sponsor verrà rimosso definitivamente.</div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button className="btn btn-ghost" style={{ flex: 1 }} onClick={() => setConfermaElimina(null)}>Annulla</button>
              <button className="btn btn-danger" style={{ flex: 1 }} onClick={() => eliminaSponsor(confermaElimina)}>Elimina</button>
            </div>
          </div>
        </div>
      )}

      {toast && <div className="toast">{toast}</div>}
    </div>
  )
}
